import { render, staticRenderFns } from "./CartGallery.vue?vue&type=template&id=a55cd43e&scoped=true&"
import script from "./CartGallery.vue?vue&type=script&lang=js&"
export * from "./CartGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55cd43e",
  null
  
)

export default component.exports